import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import { Image } from '../common';

function GalleryItem({ name, slug, photo }) {
  return (
    <div className="w-full md:w-1/2 lg:w-1/3 xl:w-1/4 p-4 mb-8 flex">
      <Link
        to={`/${slug}`}
        className="flex flex-col flex-wrap relative m-auto shadow-2xl w-full pb-4 rounded-lg"
      >
        <Image
          filename={photo}
          alt={name}
          className="w-full h-auto rounded-t-lg"
        />
        <h2 className="text-2xl text-gray-700 font-semibold pl-4">{name}</h2>
      </Link>
    </div>
  );
}

export default function Gallery() {
  const data = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          gallery {
            name
            slug
            photo
          }
        }
      }
    }
  `);
  const galleries = data.site.siteMetadata.gallery;
  return (
    <div className="p-16 bg-gray-100 mb-16">
      <div className="flex flex-row flex-wrap -mx-4">
        {galleries.map((gallery) => (
          <GalleryItem {...gallery} key={gallery.slug} />
        ))}
      </div>
    </div>
  );
}
